import { fromStatusCodeToGenericError, httpService, WebRequestFactory } from "@pjs/http";
import { apiConfig } from "../../../ApiConfig";

export const getDigestStatus = WebRequestFactory.createGet<boolean>({
    errorMapper: fromStatusCodeToGenericError,
    http: httpService,
    responseMapper: (response: Response) => response.text().then((data) => data.toLowerCase() === "true"),
    url: () => apiConfig.digestStatus()
});
